



import { Component, Vue } from 'vue-property-decorator';

import Steps from '@/shared/components/steps.component.vue';

@Component({
    components: {
        Steps,
    },
})

export default class StepsPartial extends Vue {
  private activeStep = 1;
}
